import React from "react";
import classNames from "classnames";
import { useConfig } from "../ConfigProvider";
import { CgSpinner } from "react-icons/cg";

export interface SpinnerProps {
  className?: string;
  style?: any;
  size?: string | number;
  color?: string;
  indicator?: any;
  isSpining?: boolean;
  enableTheme?: boolean;
}

const Spinner = React.forwardRef<any, SpinnerProps>((props, ref) => {
  const {
    className,
    color,
    enableTheme = true,
    indicator: Component = CgSpinner,
    isSpining = true,
    size = 20,
    style,
    ...rest
  } = props;

  const { themeColor, primaryColorLevel } = useConfig();

  const spinnerColor =
    color || (enableTheme && `${themeColor}-${primaryColorLevel}`);

  const spinnerStyle = {
    height: size,
    width: size,
    ...style,
  };

  const spinnerClass = classNames(
    isSpining && "animate-spin",
    spinnerColor && `text-${spinnerColor}`,
    className
  );

  return (
    <Component
      ref={ref}
      style={spinnerStyle}
      className={spinnerClass}
      {...rest}
    />
  );
});

export default Spinner;
